<template>
    <div class="contractVerificationDetail">
        <div class="item">
            <div class="title">
                甲方
            </div>
            <div class="content">
                <el-checkbox v-model="isCheckPartyA" class="checkbox">分公司/机构</el-checkbox>
                <div class="citem">
                    <div class="label">
                        甲方名称
                    </div>
                    <el-input v-model="editData.jfCompnayName" placeholder="请输入甲方名称" size="small" class="citem-input" disabled v-if="isCheckPartyA"></el-input>
                    <el-input v-model="editData.jfCompnayName" placeholder="请输入甲方名称" size="small" class="citem-input" v-else></el-input>
                    <el-button size="small" v-if="isCheckPartyA" type="primary" @click="selectCompany(1)">选择分公司/机构</el-button>

                </div>

                <div class="citem">
                    <div class="label">
                        联系人名称
                    </div>
                    <el-input v-model="editData.jfUserName" placeholder="请输入联系人名称" size="small" class="citem-input" disabled v-if="isCheckPartyA"></el-input>
                    <el-input v-model="editData.jfUserName" placeholder="请输入联系人名称" size="small" class="citem-input" v-else></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        联系电话
                    </div>
                    <el-input v-model="editData.jfTel" placeholder="请输入联系电话" size="small" class="citem-input" disabled v-if="isCheckPartyA"></el-input>
                    <el-input v-model="editData.jfTel" placeholder="请输入联系电话" size="small" class="citem-input" v-else></el-input>
                </div>
            </div>
        </div>
        

        <div class="item">
            <div class="title">
                乙方
            </div>
            <div class="content">
                <el-checkbox v-model="isCheckPartyB" class="checkbox">分公司/机构</el-checkbox>
                <div class="citem">
                    <div class="label">
                        乙方名称
                    </div>

                    <el-input v-model="editData.yfCompnayName" placeholder="请输入乙方名称" size="small" class="citem-input" disabled v-if="isCheckPartyB"></el-input>
                    <el-input v-model="editData.yfCompnayName" placeholder="请输入乙方名称" size="small" class="citem-input" v-else></el-input>
                    <el-button size="small" v-if="isCheckPartyB" type="primary" @click="selectCompany(2)">选择分公司/机构</el-button>
                </div>

                <div class="citem">
                    <div class="label">
                        联系人名称
                    </div>
                    <el-input v-model="editData.yfUserName" placeholder="请输入联系人名称" size="small" class="citem-input" disabled v-if="isCheckPartyB"></el-input>
                    <el-input v-model="editData.yfUserName" placeholder="请输入联系人名称" size="small" class="citem-input" v-else></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        联系电话
                    </div>
                    <el-input v-model="editData.yfTel" placeholder="请输入联系电话" size="small" class="citem-input" disabled v-if="isCheckPartyB"></el-input>
                    <el-input v-model="editData.yfTel" placeholder="请输入联系电话" size="small" class="citem-input" v-else></el-input>
                </div>
            </div>
        </div>

        <div class="item">
            <div class="title">
                涉及事业部
            </div>
            <div class="content">
                <div class="citem">
                    <el-tag
                    v-for="item in businessList"
                    :key="item.name"
                    closable
                    size="medium"
                    style="margin-bottom:5px"
                    @close="closeBusiness"
                    >
                    {{item.name}}
                    </el-tag>
                    <!-- <el-input v-model="businessName" placeholder="事业部" class="citem-input" disabled style="margin-bottom:10px"></el-input> -->
                    <el-button icon="el-icon-circle-plus" type="primary" style="margin-bottom:5px" @click="isSelectDepartment = true">添加事业部</el-button>
                </div>
            </div>
        </div>

        <div class="item">
            <div class="title">
                合同信息
            </div>
            <div class="content">
                <div class="citem">
                    <div class="label">
                        合作项目名称
                    </div>
                    <el-input v-model="editData.contractName" placeholder="请输入合作项目名称" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        合同时间
                    </div>
                    <el-date-picker
                        v-model="contractDate"
                        type="daterange"
                        size="small"
                        range-separator="至"
                        start-placeholder="合同时间起"
                        end-placeholder="合同时间止">
                    </el-date-picker>
                </div>

                <div class="citem">
                    <div class="label">
                        交付人名称
                    </div>
                    <el-input v-model="editData.contractDeliverer" placeholder="请输入交付人名称" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label" style="width:158px">
                        到期是否自动续约
                    </div>
                    <el-select v-model="editData.isAutoXy" placeholder="请选择">
                        <el-option
                        v-for="item in isAutoXyList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <!-- <el-button icon="el-icon-search" type="primary" style="margin-bottom:10px;margin-right:10px" size="small" v-if="editData.contractTemplate" @click="download">查看附件</el-button>
                <el-upload
                    :action="uploadUrl"
                    multiple
                    :show-file-list="false"
                    :http-request="contractUpload"
                    v-if="editData.contractTemplate"
                    >
                    <el-button icon="el-icon-upload2" type="primary" style="margin-bottom:10px" size="small">重新上传</el-button>
                </el-upload> -->


                <el-upload
                    :action="uploadUrl"
                    multiple
                    :show-file-list="false"
                    :http-request="contractUpload"
                    >
                    <el-button icon="el-icon-upload2" type="primary" style="margin-bottom:10px" size="small">合同模板</el-button>
                </el-upload>

                <div class="pdflist" v-if="contractTemplateList.length>0">
                    <div class="pdf" v-for="(item,index) in contractTemplateList" :key="index">
                        <img src="../../../assets/images/pdf.png" alt="" @click="lookPath(item.path)">
                        <img src="../../../assets/images/icon08.png" class="close" alt="" @click="clearPdfTip(index)">
                        <div class="pdf-title">{{item.title}}</div>
                    </div>
                </div>

            </div>
        </div>

        <div class="item">
            <div class="title">
                审核意见
            </div>
            <div class="content">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入审核意见"
                    v-model="editData.auditOpinion"
                    style="margin-bottom:3px;width:1275px">
                </el-input>
            </div>
        </div>

        <div class="item">
            <div class="title">
                补充信息
            </div>
            <div class="content">
                <div class="citem">
                    <div class="label">
                        合同编号
                    </div>
                    <el-input v-model="editData.buChongXinxi" placeholder="请输入合同编号" size="small" class="citem-input"></el-input>
                </div>

                <!-- <el-button icon="el-icon-upload2" type="primary" style="margin-bottom:10px" size="small">合同模板</el-button> -->
            </div>
        </div>

        <div class="bottom">
            <el-button type="success" @click="editContract(2)" icon="el-icon-edit-outline">审核通过</el-button>
            <el-button type="warning" @click="editContract(-1)" icon="el-icon-edit-outline">审核不通过</el-button>
            <el-button type="primary" plain @click="back">返回</el-button>
        </div>


        <el-dialog :visible.sync="isSelectCompany" title="选择分公司/机构" width="960px">
            <div class="condition">
                <div class="item" style="border:0">
                    <div class="label">分公司/机构名称:</div>
                    <el-input v-model="companyConditionData.Name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectCompanyData()">查询</el-button>
                    <el-button type="" size="small" @click="resetCompanyData()">重置</el-button>
                </div>
            </div>

            <el-table
                :data="companyList"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismCode"
                label="分公司/机构编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="分公司/机构名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contacts"
                label="分公司/机构联系人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contactsPhone"
                label="联系人电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismPerson"
                label="分公司/机构负责人"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-circle-check" size="mini" @click="affirmCompany(scope.row)">选择</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCompanyCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="companyTotalCount"
                    :current-page="companyConditionData.page"
                    :page-size="companyConditionData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>



        <el-dialog :visible.sync="isSelectDepartment" title="选择事业部" width="960px">
            <div class="condition">
                <div class="item" style="border:0">
                    <div class="label">分公司/机构名称:</div>
                    <el-input v-model="departmentConditionData.Name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectDepartmentData()">查询</el-button>
                    <el-button type="" size="small" @click="resetDepartment()">重置</el-button>
                </div>
            </div>

            <el-table
                :data="departmentList"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="code"
                label="事业部编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="事业部名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contacts"
                label="事业部联系人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contactsPhone"
                label="联系人电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="businessPerson"
                label="事业部负责人"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-circle-check" size="mini" @click="affirmDepartment(scope.row,scope.$index)" :disabled="scope.row.isSelected?true:false">选择</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleDepartmentCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="departmentTotalCount"
                    :current-page="departmentConditionData.page"
                    :page-size="departmentConditionData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- <el-dialog :visible.sync="isAuditOpinion" title="审核不通过原因" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        审核意见:
                    </div>
                    <div class="textarea">
                        <el-input v-model="this.editData.auditOpinion" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="noAudit">确认提交</el-button>
                </div>
            </div>
        </el-dialog> -->

    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeD} from '../../../utils/index'
export default {
    name: 'contractVerificationDetail',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            contractDate:null,
            businessName:'',
            isSelectCompany:false,
            isSelectDepartment:false,
            isCheckPartyA:false,
            isCheckPartyB:false,
            editData:{
                jfCompnayName:'',
                jfUserName:'',
                jfId:'',
                jfTel:'',
                yfCompnayName:'',
                yfUserName:'',
                yfId:'',
                yfTel:'',
                businessIds:'',
                contractName:'',
                contractStartDate:'',
                contractEndDate:'',
                contractDeliverer:'',
                contractTemplate:'',
                auditOpinion:'',
                buChongXinxi:'',
                formalContract:'',
                isAutoXy:null,
            },
            contractTemplateList:[],
            companyType:1,
            companyList:[],
            companyConditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            companyTotalCount:0,
            
            departmentList:[],
            isSelectDepartment:false,
            departmentTotalCount:0,
            departmentConditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            businessList:[],
            isAutoXyList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
        }
    },
    created(){
        

    },
    mounted(){
        this.queryContract();
        this.getCompany();
    },
    methods:{
        // 合同详情
        async queryContract(){
            let res = await api.queryContract(this.$route.query.id);
            console.log(res);
            this.editData = res.data.data;
            this.contractTemplateList = JSON.parse(this.editData.contractTemplate?this.editData.contractTemplate:'[]');
            this.contractDate = [this.editData.contractStartDate,this.editData.contractEndDate];
            let businessIdList = this.editData.businessIds.split(',');
            let businessNameList = this.editData.businessNames.split(',');
            for(let i in businessIdList){
                this.businessList.push({
                    name:businessNameList[i],
                    id:businessIdList[i]
                });
            }
            
            if(this.editData.jfId){
                this.isCheckPartyA = true;
            }
            if(this.editData.yfId){
                this.isCheckPartyB = true;
            }
            console.log(this.isCheckPartyA);
            console.log(this.isCheckPartyB);
            this.$forceUpdate();
            this.geDepartment();
        },
        // 返回
        back(){
            this.$router.go(-1)
        },
        async editContract(auditStatus){
            if(!this.isCheckPartyA){
                this.editData.jfId = null;
            }
            if(!this.isCheckPartyB){
                this.editData.yfId = null;
            }
            if(this.contractDate){
                console.log(this.contractDate);
                this.editData.contractStartDate = parseTimeD(this.contractDate[0]);
                this.editData.contractEndDate = parseTimeD(this.contractDate[1]);
            }
            this.editData.contractTemplate = JSON.stringify(this.contractTemplateList);
            for(let index in this.businessList){
                if(index==0){
                    this.editData.businessIds = this.businessList[index].id
                    this.editData.businessNames = this.businessList[index].name;
                }else{
                    this.editData.businessIds = this.editData.businessIds + ',' + this.businessList[index].id
                    this.editData.businessNames = this.editData.businessNames + ',' + this.businessList[index].name
                }
            }
            this.editData.auditStatus = auditStatus;
           
            let res = await api.updateContract(this.editData);
            console.log(res);
            if(res.data.code == '200'){
                this.$message({
                    message: '审核完成',
                    type: 'success'
                })
                this.$router.go(-1)
            }
        },
        // 选择公司对话框
        async selectCompany(type){
            this.companyType = type;
            this.isSelectCompany = true;
        },
        // 条件查询公司列表
        selectCompanyData(){
            this.companyConditionData.page = 1;
            this.getCompany();
        },
        // 重置公司列表
        resetCompanyData(){
            this.companyConditionData = {
                Name:'',
                page:1,
                pageSize:10,
            }
            this.getCompany();
        },
        // 获取公司列表
        async getCompany(){
            let res  = await api.QueryMechanism(this.companyConditionData);
            this.companyList = res.data.data.data;
            this.companyTotalCount = res.data.data.totalCount;
            this.$forceUpdate();
        },
        // 公司列表分页
        handleCompanyCurrentChange(page){
            this.companyConditionData.page = page;
            this.getCompany();
        },
        // 确定选择公司
        affirmCompany(row){
            console.log(row);
            if(this.companyType == 1){
                this.editData.jfId = row.id;
                this.editData.jfCompnayName = row.name;
                this.editData.jfUserName = row.contacts;
                this.editData.jfTel = row.contactsPhone;
            }else{
                this.editData.yfId = row.id;
                this.editData.yfCompnayName = row.name;
                this.editData.yfUserName = row.contacts;
                this.editData.yfTel = row.contactsPhone;
            }
            this.isSelectCompany = false;
        },
        // 重置部门列表
        resetDepartment(){
            this.departmentConditionData = {
                Name:'',
                page:1,
                pageSize:10,
            }
            this.geDepartment();
        },
        // 查询部门
        selectDepartmentData(){
            this.departmentConditionData.page = 1;
            this.geDepartment();
        },
        // 获取部门列表
        async geDepartment(){
            let res  = await api.QueryCauseList(this.departmentConditionData);
            console.log(res);
            this.departmentList = res.data.data.data;
            this.departmentTotalCount = res.data.data.totalCount;
            for(let i in this.departmentList){
                for(let j in this.editData.businessResponses){
                    if(this.editData.businessResponses[j].id == this.departmentList[i].id){
                        this.departmentList[i].isSelected = true;
                        break; 
                    }
                }
            }
            console.log(this.departmentList);
            this.$forceUpdate();
        },
        // 部门列表分页
        handleDepartmentCurrentChange(page){
            this.departmentConditionData.page = page;
            this.getDepartment();
        },
        // 确认选择部门
        affirmDepartment(row,index){
            this.businessList.push({
                name:row.name,
                id:row.id
            });
            this.departmentList[index].isSelected = this.$set(this.departmentList[index],'isSelected',true);
            this.$forceUpdate();
            this.$message({
                message: '添加成功',
                type: 'success'
            });
        },
        // 上传合同
        async contractUpload(file){
            console.log(file);
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.contractTemplateList.push({
                title:file.file.name,
                path:res
            });
        },

        closeBusiness(tag){
            let item = this.businessList.indexOf(tag)
            this.businessList.splice(item,1);
        },
        download(){
            const elt = document.createElement('a');
            elt.setAttribute('href', this.editData.contractTemplate);
            // elt.setAttribute('download', 'file.png');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        lookPath(path){
            console.log(path);
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            // elt.setAttribute('download', 'file.png');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
           
        },

        clearPdfTip(index){
            this.$confirm('确认删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearPdf(index);
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        clearPdf(index){
            this.contractTemplateList.splice(index,1);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .contractVerificationDetail{
        .item{
            border: 1px solid #eee;
            box-shadow: 0 1px 4px rgbe(0,21,41,8%);
            display: flex;
            flex-wrap: wrap;
            padding:2px 15px;
            padding-top: 10px;
            margin-bottom: 10px;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 12px;
            }
            .content{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 16px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 10px;
                    .label{
                        width: 125px;
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
            }
            .pdflist{
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                border: 1px solid #eee;
                margin-bottom: 10px;
                .pdf{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 200px;
                    padding-bottom: 10px;
                    position: relative;
                    padding-top: 10px;
                    img{
                        width: 160px;
                        height: 160px;
                    }
                    .close{
                        width: 30px;
                        height: 30px;
                        position: absolute;
                        right: 0;
                    }
                    .pdf-title{
                        width: 180px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 14px;
                        text-align: center;
                        font-weight: bold;
                    }
                }
            }
        }
        .bottom{
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }

    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding-bottom: 15px;
        
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            width: 300px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
</style>
